/* custom code start */
/*
 * occ-cart-auto-clear
 *
 * Free add-ons — "Deneme Boy" sample sets (GWP) and the "Özel Paketleme"
 * gift/packaging items — are flagged in Liquid with data-cart-item-aux="true"
 * (is_gwp metafield or SATILAMAZ tag). On their own they are worth 0 TL, so if
 * the customer removes the last real product the cart would otherwise keep the
 * freebies and let them check out paying only shipping.
 *
 * Two things happen when only auxiliary lines remain:
 *   1. Checkout is blocked immediately — the buttons are disabled and any
 *      submit/click is cancelled in the capture phase. This closes the race
 *      window where the customer could reach Shopify's checkout (which our
 *      theme JS can't touch) during the clear + reload.
 *   2. The whole cart is cleared and the page reloaded into a proper empty cart.
 */
(function () {
  if (window.__occCartAutoClearInit) return;
  window.__occCartAutoClearInit = true;

  var isClearing = false;

  // True from the moment a line-item removal / quantity change is initiated
  // until cartUpdate confirms the new cart state. While set, checkout is
  // locked: the server-side cart may already contain only freebies even
  // though the DOM still shows the removed real item.
  var pendingMutation = false;
  var pendingTimer = null;

  var CHECKOUT_SELECTOR = '#checkout, #CartDrawer-Checkout, [name="checkout"]';
  var DYNAMIC_CHECKOUT_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // True when a container has rendered cart rows and ALL of them are auxiliary.
  // Each container (cart page table / cart drawer) is checked independently: the
  // one the customer just acted on is re-rendered and authoritative, while a
  // stale container still shows a real item and simply won't match.
  function hasOnlyAuxiliaryItems() {
    var containers = document.querySelectorAll('cart-items, cart-drawer-items');

    for (var i = 0; i < containers.length; i++) {
      var rows = containers[i].querySelectorAll('.cart-item');
      if (!rows.length) continue;

      var allAux = true;
      for (var j = 0; j < rows.length; j++) {
        if (rows[j].dataset.cartItemAux !== 'true') {
          allAux = false;
          break;
        }
      }

      if (allAux) return true;
    }

    return false;
  }

  function disableCheckout() {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      // Remember which buttons WE disabled so enableCheckout() never
      // re-enables one that was disabled by the theme (e.g. empty cart).
      if (!btn.hasAttribute('disabled')) {
        btn.setAttribute('data-occ-auto-clear-disabled', 'true');
      }
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
    });

    // Dynamic / express buttons (Shop Pay etc.) can't be disabled directly, so
    // make them non-interactive while the cart is being emptied.
    document.querySelectorAll(DYNAMIC_CHECKOUT_SELECTOR).forEach(function (el) {
      el.style.pointerEvents = 'none';
      el.style.opacity = '0.5';
    });
  }

  function enableCheckout() {
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (btn.getAttribute('data-occ-auto-clear-disabled') === 'true') {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('data-occ-auto-clear-disabled');
      }
    });

    document.querySelectorAll(DYNAMIC_CHECKOUT_SELECTOR).forEach(function (el) {
      el.style.pointerEvents = '';
      el.style.opacity = '';
    });
  }

  // Lock checkout as soon as the customer starts changing the cart. Released
  // by the cartUpdate that follows, or by the fallback timer if the request
  // failed (in which case the DOM was never re-rendered and still reflects
  // the real server state).
  function beginMutationLock() {
    pendingMutation = true;
    disableCheckout();

    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      pendingTimer = null;
      pendingMutation = false;
      check();
    }, 8000);
  }

  function releaseMutationLock() {
    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }
    pendingMutation = false;
  }

  function onCartMutation(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (event.type === 'click') {
      if (!target.closest('cart-remove-button')) return;
    } else {
      // change event from the quantity steppers / inputs
      if (!target.classList || !target.classList.contains('quantity__input')) return;
      if (!target.closest('cart-items, cart-drawer-items')) return;
    }

    beginMutationLock();
  }

  function clearCart() {
    if (isClearing) return;
    isClearing = true;

    fetch(rootUrl() + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) throw new Error(response.statusText);
        return response.json();
      })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        // Allow another attempt on the next cart update if the request failed.
        // Checkout stays blocked by the capture-phase guards below while the
        // cart is still invalid.
        isClearing = false;
      });
  }

  function check() {
    if (isClearing) return;
    if (hasOnlyAuxiliaryItems()) {
      // Block checkout synchronously, then empty the cart.
      disableCheckout();
      clearCart();
    } else if (!pendingMutation) {
      // Cart is valid and no mutation is in flight: lift our lock (no-op for
      // buttons the theme disabled itself).
      enableCheckout();
    }
  }

  // Capture-phase guards: even if a button is clicked in the brief window before
  // the cart is cleared, the navigation to checkout is cancelled synchronously.
  function shouldBlockCheckout() {
    return isClearing || pendingMutation || hasOnlyAuxiliaryItems();
  }

  function onCheckoutClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest(CHECKOUT_SELECTOR + ', ' + DYNAMIC_CHECKOUT_SELECTOR)) return;

    if (shouldBlockCheckout()) {
      event.preventDefault();
      event.stopPropagation();
      check();
    }
  }

  function onCartSubmit(event) {
    var form = event.target;
    if (!form || form.id !== 'cart') return;

    if (shouldBlockCheckout()) {
      event.preventDefault();
      event.stopPropagation();
      check();
    }
  }

  function init() {
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onCartSubmit, true);

    // Lock checkout the instant a removal / quantity change is initiated.
    document.addEventListener('click', onCartMutation, true);
    document.addEventListener('change', onCartMutation, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      // cart.js / cart-drawer.js re-render their sections before publishing
      // cartUpdate, so the DOM already reflects the new cart state here.
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        releaseMutationLock();
        check();
      });
    }

    // Also catch a fresh page load that already shows only freebies.
    check();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* custom code end */
